import * as React from "react";
import type { SVGProps } from "react";

const getTheme = (theme) => {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
const SvgTwoColorBail = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill={getTheme(props["data-theme"])}
      d="m11.085 21.535-.334-.171c-1.684-.863-5.029-2.575-7.209-6.208-.738-1.231-1.087-2.9-1.277-4.368C2.066 9.253 2.008 7.644 2 6.354A2.382 2.382 0 0 1 3.794 4.04l7.478-1.948a2.89 2.89 0 0 1 1.456 0l7.478 1.948-.378 1.451-7.478-1.947a1.39 1.39 0 0 0-.7 0L4.172 5.492a.882.882 0 0 0-.672.852c.008 1.261.065 2.802.252 4.252.186 1.433.506 2.838 1.077 3.788 1.941 3.237 4.933 4.788 6.606 5.645h.002l.34.176.218.113.219-.109c.227-.112.508-.229.767-.337l.032-.013c1.735-.723 4.681-1.975 6.246-5.523.942-2.133 1.218-5.508 1.241-7.99a.88.88 0 0 0-.672-.854l.378-1.451A2.38 2.38 0 0 1 22 6.359c-.023 2.493-.292 6.144-1.368 8.583-1.82 4.126-5.277 5.566-7.042 6.301-.286.12-.528.22-.71.31l-.903.447-.892-.465Z"
    />
    <path
      fill="#F7A600"
      d="M11.999 5.593a.75.75 0 0 1 .75.75v.72h1.454a.75.75 0 0 1 0 1.5H12.01a.757.757 0 0 1-.023 0h-1.09a1.087 1.087 0 0 0 0 2.173H13.1a2.587 2.587 0 1 1 0 5.173h-.352v.72a.75.75 0 0 1-1.5 0v-.72H9.795a.75.75 0 0 1 0-1.5H13.1a1.087 1.087 0 0 0 0-2.173h-2.204a2.587 2.587 0 0 1 0-5.174h.352v-.72a.75.75 0 0 1 .75-.75Z"
    />
  </svg>
);
export default SvgTwoColorBail;
